import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconCloudArrowUp20(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={20}
            height={20}
            className={customClassName}
            name="IconCloudArrowUp20"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="m16.087 9.401-.096.808.624.521c.556.465.885 1.126.885 1.845 0 1.305-1.125 2.475-2.654 2.475H5.154c-1.529 0-2.654-1.17-2.654-2.475 0-.89.508-1.7 1.325-2.143l.911-.493-.138-1.026a2 2 0 0 1-.021-.313c0-1.306 1.125-2.475 2.654-2.475q.219 0 .426.031l.663.1.517-.428A4.52 4.52 0 0 1 11.731 4.8c2.484 0 4.385 1.911 4.385 4.131q0 .24-.029.47m-1.24 7.149H5.153C2.86 16.55 1 14.77 1 12.575c0-1.485.85-2.78 2.111-3.462a4 4 0 0 1-.034-.513c0-2.196 1.86-3.975 4.154-3.975q.33 0 .649.048A6.02 6.02 0 0 1 11.73 3.3c3.25 0 5.886 2.521 5.886 5.631q0 .33-.04.648c.873.73 1.424 1.8 1.424 2.996 0 2.195-1.86 3.975-4.154 3.975m-7.499-5.641a.75.75 0 0 1 0-1.06L9.47 7.726l.53-.53.531.53 2.121 2.121a.75.75 0 1 1-1.06 1.06l-.84-.84V13a.75.75 0 0 1-1.5 0v-2.932l-.842.84a.75.75 0 0 1-1.06 0"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconCloudArrowUp20);
